import { createAction } from 'redux-actions'
import * as request from 'superagent'
import _ from 'lodash'
import { arrayOf, normalize, Schema } from 'normalizr'
import moment from 'moment'
import {
  change as changeFieldValue,
  destroy,
  getValues,
  reset
} from 'redux-form'
import { addressFields, DATE_STANDARD_FORMAT } from '../constants'
import { getObjVal, isEmpty, isEmptyArray } from '../utils'
import {
  clearAppCache,
  sortRooms,
  validateRoomsPrice
} from '../redux/stateUtils'
import $ from 'jquery'
import { reason, status } from '../constants/apiConstants'
import {
  populateFormErrors,
  resetErrorValues
} from './modules/errorDialogModule'
import {
  checkInDateSelector,
  checkOutDateSelector,
  clearRoomSearchResults,
  exitProgramBooking,
  programDetailsSelector,
  programSelector,
  resetSearchParams
} from './modules/searchParamsModule'
import { dateToString } from '../utils/dateUtils'
import history from '../history'
import { roomTypes } from '../constants/roomConstants'
import { cancelTransfer } from './modules/roomTransferModule'
import {
  clearPayment,
  preparePaymentSuccess,
  updateTotalPayment
} from './modules/paymentModule'

const visit = new Schema('visits')
const contact = new Schema('contacts')

visit.define({
  guest: contact
})

let holdTimer = null

export const findRoomsSuccess = createAction('FIND_ROOMS_SUCCESS')
export const getAllRoomsSuccess = createAction('GET_ALL_ROOMS_SUCCESS')
export const findLocalRooms = createAction('FIND_LOCAL_ROOMS')
export const getStorageGuestInfo = createAction('GET_STORAGE_GUEST_INFO')
export const updateRoomSuccess = createAction('UPDATE_ROOM_SUCCESS')

export const submitBookRequest = createAction('SUBMIT_BOOK')
export const changeBookingStatus = createAction('CHANGE_BOOKING_STATUS_ENTRY')
export const loadBookingStatusFromCache = createAction('LOAD_STATUS_FROM_CACHE')

export const changeRoomCount = createAction('CHANGE_ROOM_COUNT')
export const changeRoomSelection = createAction('CHANGE_ROOM_SELECTION')
export const setRoomUseCustomPrice = createAction('SET_ROOM_USE_CUSTOM_PRICE')
export const changeRoomPrice = createAction('CHANGE_ROOM_PRICE')
export const changeGuestCount = createAction('CHANGE_GUEST_COUNT')
export const changeGuestInfo = createAction('CHANGE_GUEST_INFO')
export const setDefaultPrimaryGuest = createAction('SET_DEFAULT_PRIMARY_GUEST')

export const holdRoomsRequest = createAction('HOLD_ROOMS_REQUEST')
export const holdRoomsSuccess = createAction('HOLD_ROOMS_SUCCESS')
export const loadHoldStatus = createAction('LOAD_HOLD_STATUS')
export const holdExpired = createAction('HOLD_EXPIRED')
export const cancelled = createAction('CANCELLED')
export const holdTimerTick = createAction('HOLD_TIMER_TICK')
export const _holdStatusReset = createAction('HOLD_STATUS_RESET')

export const showFlaggedContactDialog = createAction(
  'SHOW_FLAGGED_CONTACT_DIALOG'
)
export const flaggedContactDialogReset = createAction(
  'FLAGGED_CONTACT_DIALOG_RESET'
)
export const flaggedContactDialogContinueBooking = createAction(
  'FLAGGED_CONTACT_DIALOG_CONTINUE_BOOKING'
)

export const bookRoomsSuccess = createAction('BOOK_ROOMS_SUCCESS')

export const getVisitsSuccess = createAction('GET_VISITS_SUCCESS')
export const getVisitsStart = createAction('GET_VISITS_START')
export const getVisitsError = createAction('GET_VISITS_ERROR')
export const updateVisitSuccess = createAction('UPDATE_VISIT_SUCCESS')

export const guestUser = createAction('GUEST_USER')
export const authenticatedUser = createAction('AUTH_USER')
export const initPrices = createAction('INIT_PRICES')
export const histSearchPage = createAction('SEARCH_PAGE')
export const histResultsPage = createAction('RESULTS_PAGE')
export const localRoomResults = createAction('FIND_LOCAL_ROOMS_RESULTS')
export const histGuestEntryPage = createAction('GUEST_ENTRY_PAGE')
export const histPaymentPage = createAction('PAYMENT_PAGE')

export const dashboard = require('./actions/dashboardActions')
export const search = require('./actions/searchActions')
let { openWarningDialog, extendTime } = search

export function getAllRooms() {
  return function(dispatch) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: '/api/rooms',
        dataType: 'json',
        success: function(data) {
          dispatch(getAllRoomsSuccess(data))
          resolve(data)
        },
        error: function(xhr, status, err) {
          console.error('Error getting all rooms', err)
          reject(err)
        }
      })
    })

    /*
        Alternative using superagent:
        return request.get('/api/rooms').end((err, res) => { ... })
    */
  }
}

// Finds the new rooms for booking in given check-in and checkout dates
export function findRooms(checkInDate, checkOutDate) {
  return function(dispatch) {
    return new Promise((resolve, reject) => {
      localStorage.removeItem('fields')
      $.ajax({
        url: '/api/rooms/query',
        dataType: 'json',
        data: {
          checkInDate: dateToString(checkInDate),
          checkOutDate: dateToString(checkOutDate)
        },
        success: function(data) {
          // todo: check if we need to destroy this??
          dispatch(destroy('roomSelection'))
          if (data.length === 0) {
            dispatch(populatePopupError('No rooms were found for these dates'))
          } else {
            let sortedRooms = sortRooms(data)
            let disRet = dispatch(findRoomsSuccess(sortedRooms))
            resolve(sortedRooms)
          }
        },
        error: function(xhr, status, err) {
          console.log('error!', err)
          dispatch(
            populateFormErrors({
              messages: [
                getErrorMessage('', 'An error occured searching for rooms')
              ],
              popupError: true
            })
          )
          reject('Error while finding the room')
        }
      })
    }).then(
      () => {},
      error => {
        console.log('Error while finding the room', error)
      }
    )
  }
}

export function updateRoom(params) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      request
        .post('/api/rooms')
        .send(params)
        .end((err, res) => {
          if (res.ok) {
            resolve(res.body)
          } else {
            reject(err)
          }
        })
    }).then(
      () => dispatch(updateRoomSuccess(params)),
      error => {
        console.log('Error updating room', error)
        dispatch(
          populateFormErrors({
            messages: ['There was an error updating the room']
          })
        )
      }
    )
  }
}
// Room booking timer will be started and sets the functionality for expiring the page once the time has expired
export function startHoldTimer() {
  return (dispatch, getState) => {
    holdTimer = setInterval(() => {
      let expireTime = getState().roomSearch.holdStatus.expireTime
      let warnTime = getState().roomSearch.holdStatus.warnTime
      if (moment().isBefore(expireTime)) {
        dispatch(holdTimerTick())
        if (
          moment().isAfter(warnTime) &&
          !getState().roomSearch.holdStatus.popupShown &&
          !getState().roomSearch.holdStatus.closedPopup
        ) {
          dispatch(openWarningDialog())
        }
      } else {
        let cancelled = getState().roomSearch.holdStatus.status === 'cancelled'
        let prevPage = getState().common.history.prevPage
        if (getState().roomSearch.holdStatus.status != 'cancelled') {
          dispatch(holdExpired())
        }
        if (!cancelled && prevPage != 'PAYMENT') {
          history.push('/search')
        }
        dispatch(holdStatusReset())
      }
    }, 1000)
  }
}

export function stopHoldTimer() {
  return (dispatch, getState) => {
    clearInterval(holdTimer)
    holdTimer = null
  }
}

export function holdStatusReset() {
  return (dispatch, getState) => {
    dispatch(stopHoldTimer())
    dispatch(_holdStatusReset())
  }
}
// Extends the timer duration to next consecutive interval
export function extendHoldTimer() {
  return (dispatch, getState) => {
    dispatch(extendTime())
    dispatch(extHoldRooms())
  }
}
// Holds the selected rooms and locks the rooms until the booking is completed.
export function holdRooms(formData) {
  return (dispatch, getState) => {
    const state = getState()
    const checkInDate = checkInDateSelector(state)
    const checkOutDate = checkOutDateSelector(state)
    const program = programSelector(state)
    const programDetails = programDetailsSelector(state)
    const selectedRooms = _.flatMap(formData.listings, listing => listing.rooms)
    const roomIds = _.map(selectedRooms, room =>
      room.roomId ? { roomId: getObjVal(room.roomId) } : {}
    )

    // Validation logic

    if (!roomIds || roomIds.length === 0) {
      dispatch(populatePopupError('Please select at least one room'))
      return
    }

    let hasEmptyRooms = false
    roomIds.map(roomObj => {
      if (isEmpty(roomObj)) {
        hasEmptyRooms = true
      }
    })

    if (hasEmptyRooms) {
      dispatch(populatePopupError('Please select room type'))
      return
    }

    const minStudioGuests = programDetails.minStudioGuests
    if (minStudioGuests) {
      const hasLessThanMinGuests = _.some(
        selectedRooms,
        ({ roomId, guests }) =>
          state.rooms[roomId].type === roomTypes.studio &&
          guests.length < minStudioGuests
      )
      if (hasLessThanMinGuests) {
        dispatch(
          populatePopupError(
            `Please book at least ${minStudioGuests} guests in each studio. ` +
              `Single guests could instead stay in lodges or Mahima`
          )
        )
        return
      }
    }

    // End validation logic

    $.ajax({
      url: '/api/rooms/hold',
      dataType: 'json',
      type: 'POST',
      data: {
        rooms: roomIds,
        checkInDate: dateToString(checkInDate),
        checkOutDate: dateToString(checkOutDate)
      },
      success: function(data) {
        if (data.status !== status.success) {
          if (data.reason === reason.roomsNotAvailable) {
            dispatch(
              populatePopupError(
                'The rooms you selected may no longer be available. ' +
                  'Please retry searching for rooms on your desired dates.'
              )
            )
          } else {
            populatePopupError(
              'There was an error. Please try again or call ' +
                extConfig.SUPPORT_CONTACT +
                ' for assistance.'
            )
          }
        } else {
          localStorage.removeItem('holds')
          localStorage.setItem('holds', JSON.stringify(data))
          dispatch(holdRoomsSuccess(data))
          history.push('/guestentry')
          dispatch(startHoldTimer())
        }
      },
      error: function(xhr, status, err) {
        console.log('error with hold!', err)
        dispatch(
          populateFormErrors({
            messages: [getErrorMessage('', 'An error occured holding rooms')]
          })
        )
      }
    })
  }
}

// Sends the request to server for extending the hold room timer at server side
export function extHoldRooms() {
  return (dispatch, getState) => {
    let { roomSearch } = getState()
    let {
      params: { checkInDate, checkOutDate }
    } = roomSearch
    request
      .post('/api/rooms/extHold')
      .send({
        checkInDate: moment(checkInDate).format(DATE_STANDARD_FORMAT),
        checkOutDate: moment(checkOutDate).format(DATE_STANDARD_FORMAT)
      })
      .end((err, res) => {
        if (res.ok) {
        } else {
        }
      })
  }
}

// Unlocks the rooms
export function unlockRooms() {
  return (dispatch, getState) => {
    request.post('/api/rooms/unHoldSessionRooms').end((err, res) => {
      if (res.ok) {
        dispatch(cancelled())
      } else {
      }
    })
  }
}

/**
 * Resets all room booking state to go back to initial values
 * @returns {Function}
 */
export function resetRoomBookingState() {
  return function(dispatch, getState) {
    dispatch(unlockRooms)
    dispatch(holdStatusReset())
    dispatch(changeBookingStatus('NONE'))
    dispatch(clearRoomSearchResults())
    dispatch(clearPayment())
    // Reset samyama booking state here
    if (getState().roomSearch.params.isProgramBooking) {
      dispatch(exitProgramBooking({ redirect: false })).then(() => {
        dispatch(resetSearchParams())
      })
    }
  }
}

export const submitBook = (bypassPayment = false, params) => (
  dispatch,
  getState
) => {
  console.log('submitBook')
  let { form, roomSearch } = getState()
  let formValues = getValues(form.roomSelection)
  let {
    params: { checkInDate, checkOutDate }
  } = roomSearch

  let guestEntryCommonFields = formValues.commonGuestFields
  let requestData = {
    bypassPayment: bypassPayment,
    ...guestEntryCommonFields
  }

  let addressData = _.reduce(
    addressFields,
    (value, field) => {
      value[field] = guestEntryCommonFields[field]
    },
    {}
  )
  if (
    _(addressData)
      .values()
      .some()
  ) {
    requestData.address = addressData
  }
  return new Promise((resolve, reject) => {
    $.ajax({
      url: '/api/rooms/submitPaymentAndBookRoom',
      dataType: 'json',
      type: 'POST',
      data: {
        bookingParams: params,
        formData: requestData,
        checkInDate: moment(checkInDate).format(DATE_STANDARD_FORMAT),
        checkOutDate: moment(checkOutDate).format(DATE_STANDARD_FORMAT)
      },
      success: function(data) {
        if (data.status === 'FAILED') {
          dispatch(
            populateFormErrors({ messages: [data.message], popupError: true })
          )
        } else {
          dispatch(reset('guestEntry'))
          dispatch(bookRoomsSuccess(data))
          dispatch(holdStatusReset())
          history.push('/success')
          // to change the booking status and handle the url security issues.
          dispatch(changeBookingStatus('PAYMENT_COMPLETED'))
          clearAppCache()
          localStorage.removeItem('searchDetails')
          window.scrollTo(0, 0)
        }
        resolve(data)
      },
      error: function(xhr, status, err) {
        reject(err)
      }
    })
  }).catch(event => {
    console.error('Error in submitting payment', event)

    dispatch(
      populatePopupError(
        'There was an error with processing the payment. ' +
          'Please call the Welcome Center for assistance at ' +
          extConfig.SUPPORT_CONTACT
      )
    )
  })
}

// TODO: Cache visits
export function getVisits(startDate, endDate) {
  return (dispatch, getState) => {
    dispatch(getVisitsStart())
    request
      .get('/api/visits')
      .query({ startDate, endDate })
      .end((err, res) => {
        if (res.ok) {
          let normalized = normalize(res.body, { visits: arrayOf(visit) })
          dispatch(getVisitsSuccess(normalized))
        } else {
          dispatch(getVisitsError())
          console.error('error with getting visits!', err)
        }
      })
    dispatch(cancelTransfer())
  }
}

export function updateVisit(params) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      request
        .post('/api/visits')
        .send(params)
        .end((err, res) => {
          if (res.ok) {
            resolve(res.body)
          } else {
            reject(err)
          }
        })
    }).then(() => {
      return dispatch(updateVisitSuccess(params))
    })
  }
}

function getErrorMessage(messageBody, defaultMessage) {
  var message = ''
  messageBody = _.uniq(messageBody, function(e) {
    return e.param
  })
  messageBody.forEach(function(obj) {
    if (obj.param && obj.msg) {
      message += '\n' + obj.param + ': ' + obj.msg
    }
  })
  if (message === '') {
    message = defaultMessage
  }
  console.log('Error: ' + message)
  return message
}

export function preparePayment(formData, totalPayment) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      let {
        roomSearch: {
          params: { checkInDate, checkOutDate },
          flaggedContact
        },
        common: {
          history: { prevPage },
          authentication: { authenticated }
        },
        rooms,
        form
      } = getState()
      let pricePanelFormData = getValues(form.pricePanel)
      let guestsDetails = formData.guestDetails
      let messages = validateRoomsPrice(
        authenticated,
        formData.listings,
        rooms,
        '',
        true,
        guestsDetails,
        dispatch
      )
      if (!isEmptyArray(messages)) {
        reject({ messages: messages, popupError: false })
      } else {
        _.flatMap(formData.listings, (listingField, listingIndex) => {
          _.map(listingField.rooms, (roomField, roomIndex) => {
            if (roomField && roomField.roomId) {
              let roomGuestDetails = _.filter(guestsDetails, guest => {
                return getObjVal(guest.room) === getObjVal(roomField.roomId)
              })
              if (roomGuestDetails && roomGuestDetails.length > 0) {
                if (
                  getObjVal(roomGuestDetails[0].room) ==
                  getObjVal(guestsDetails[0].room)
                ) {
                  // Hard-coding guests index to zero, because the occurrence of the paying guest in this assignment will be always zero'th
                  formData.payingGuest =
                    'listings[' +
                    listingIndex +
                    '].rooms[' +
                    roomIndex +
                    '].guests[0]'
                }
                _.map(roomGuestDetails, (guestDetails, guestIndex) => {
                  roomField.guests[guestIndex] = guestDetails
                })
              }
            }
          })
        })
        if (
          getObjVal(formData.payingGuest) !=
          'listings[0].rooms[0].guests[0].isPrimary'
        ) {
          if (_.get(formData, 'listings[0].rooms[0].guests[0]')) {
            _.set(formData, 'listings[0].rooms[0].guests[0].isPrimary', false)
          }
          _.set(formData, getObjVal(formData.payingGuest) + '.isPrimary', true)
        }
        let payingGuest = _.get(formData, getObjVal(formData.payingGuest))
        if (getObjVal(payingGuest.guestType) == 'child') {
          reject({
            messages: ['Paying guest can not be a child'],
            popupError: false
          })
        }
        resetErrorValues({})
        let requestData = {
          selections: formData.listings,
          checkInDate,
          checkOutDate,
          paymentComment: pricePanelFormData.comment,
          prevPage: prevPage,
          flaggedContactContinueBooking: flaggedContact.continueBooking
        }
        // Converts the ordered guest details to form listing

        // TODO: Uncomment once the coding is implemented

        if (pricePanelFormData.useCustomAmount) {
          requestData.useCustomAmount = true
          requestData.customAmount = pricePanelFormData.customAmount
          dispatch(
            updateTotalPayment({ amount: pricePanelFormData.customAmount })
          )
        } else {
          dispatch(updateTotalPayment({ amount: totalPayment }))
        }

        $.ajax({
          url: '/api/payment/prepare',
          dataType: 'json',
          type: 'POST',
          data: JSON.stringify(requestData),
          contentType: 'application/json',
          success: function(data) {
            if (data.status === 'warning-flag' || data.status === 'error') {
              reject(data)
            } else {
              resolve(data)
            }
          },
          error: function(xhr, status, err) {
            reject(err)
          }
        })
        dispatch(flaggedContactDialogReset())
      }
    })
      .then(data => {
        dispatch(preparePaymentSuccess(data))
        let uri = '/payment'
        return history.push(uri)
      })
      .catch(error => {
        if (error.status === 'warning-flag') {
          console.log('Contact flagged, not going to payment page')
          dispatch(showFlaggedContactDialog({ contact: error.contact }))
          return
        } else if (error.status === 'error') {
          if (error.reason === 'invalid-email') {
            dispatch(
              populatePopupError(
                'Based on our records, you have not signed up for the Samyama program. Please complete the registration form first and then book accommodations.'
                // + ' Guests who have not signed up: ' +
                //    error.invalidEmails.join(', ')
              )
            )
          } else if (error.reason === 'duplicate-email') {
            dispatch(
              populatePopupError(
                'Please ensure each guest uses a unique email, the same one they used to register for the program.'
              )
            )
          } else {
            dispatch(
              populatePopupError(
                'There was an error with booking your stay. Please try again at a later time.'
              )
            )
          }

          return
        }

        console.log('Error preparing payment', error)
        if (error && error.messages) {
          dispatch(populateFormErrors(error))
          window.scrollTo(0, 0)
        } else {
          dispatch(
            populateFormErrors({
              messages: ['There was an error with your request']
            })
          )
          window.scrollTo(0, 0)
        }
      })
  }
}

export function initRoomPrices(callback) {
  return (dispatch, getState) => {
    $.ajax({
      url: '/api/rooms/getPrices',
      type: 'GET',
      success: function(resp) {
        dispatch(initPrices(resp.data))
        if (callback) callback()
      },
      error: function(xhr, status, err) {
        console.log('Error with booking!', err)
      }
    })

    /* request
            .get('/api/rooms/getPrices')
            .end((err, res) => {
                if (res.ok) {
                    if(res.body.data) {
                        dispatch(initPrices(res.body.data));
                        if(callback)callback();
                    }
                } else {
                    console.log('error with booking!', err)
                }
            }) */
  }
}

// Logout from the application
export function logout(sessionExpired) {
  return (dispatch, getState) => {
    request.get('/api/logout').end((err, res) => {
      if (res.ok) {
        if (sessionExpired || res.body.logout) {
          dispatch(unlockRooms())
          dispatch(guestUser())
          history.push('/login')
        }
      } else {
        console.log('error while logging out..', err)
      }
    })
  }
}
// Populates the given error message in a new popup
export function populatePopupError(message) {
  return (dispatch, getState) => {
    dispatch(populateFormErrors({ messages: [message], popupError: true }))
  }
}
// Resets the Guest rooms before opening the guestdetails form
export function resetGuestRoomNames(guestDetails) {
  return (dispatch, getState) => {
    _.map(guestDetails, (guest, guestIndex) => {
      dispatch(
        changeFieldValue(
          'roomSelection',
          'guestDetails[' + guestIndex + '].room',
          ''
        )
      )
    })
  }
}

// --------------------- Cached values retain methods ---------//
// Below method will get the appropriate guestDetails obj values from cache when the page is refreshed
export function formatGuestDetails(guestDetails) {
  _.map(guestDetails, (guestField, guestIndex) => {
    guestField.room = getObjVal(guestField.room)
    guestField.email = getObjVal(guestField.email)
    guestField.firstName = getObjVal(guestField.firstName)
    guestField.lastName = getObjVal(guestField.lastName)
    guestField.gender = getObjVal(guestField.gender)
    guestField.guestType = getObjVal(guestField.guestType)
    guestField.isAnonymous = getObjVal(guestField.isAnonymous)
    guestField.isMeditator = getObjVal(guestField.isMeditator)
    guestField.phone = getObjVal(guestField.phone)
    guestField.isPrimary = getObjVal(guestField.isPrimary)
  })
  return guestDetails
}
// Below method will get the appropriate Listings obj values from cache when the page is refreshed
export function formatListings(listings) {
  _.map(listings, (listingEntry, listingIndex) => {
    listingEntry.numRooms = getObjVal(listingEntry.numRooms)
    _.map(listingEntry.rooms, (roomEntry, roomIndex) => {
      roomEntry.customPrice = getObjVal(roomEntry.customPrice)
      _.map(roomEntry.guests, (guestEntry, guestIndex) => {
        guestEntry.email = getObjVal(guestEntry.email)
        guestEntry.firstName = getObjVal(guestEntry.firstName)
        guestEntry.gender = getObjVal(guestEntry.gender)
        guestEntry.guestType = getObjVal(guestEntry.guestType)
        guestEntry.isAnonymous = getObjVal(guestEntry.isAnonymous)
        guestEntry.isMeditator = getObjVal(guestEntry.isMeditator)
        guestEntry.isPrimary = getObjVal(guestEntry.isPrimary)
        guestEntry.lastName = getObjVal(guestEntry.lastName)
        guestEntry.phone = getObjVal(guestEntry.phone)
        guestEntry.room = getObjVal(guestEntry.room)
        guestEntry.isPrimary = getObjVal(guestEntry.isPrimary)
      })
      roomEntry.numGuests = getObjVal(roomEntry.numGuests)
      roomEntry.numChildren = getObjVal(roomEntry.numChildren)
      roomEntry.order = getObjVal(roomEntry.order)
      roomEntry.roomId = getObjVal(roomEntry.roomId)
      roomEntry.roomConfiguration = getObjVal(roomEntry.roomConfiguration)
      roomEntry.useCustomPrice = getObjVal(roomEntry.useCustomPrice)
    })
  })
  return listings
}
// Below method will get the appropriate commonGuestDetails obj values from cache when the page is refreshed
export function formatCommonGuestFields(commonGuestFields) {
  if (commonGuestFields) {
    commonGuestFields['howDidYouHear'] = getObjVal(
      commonGuestFields['howDidYouHear']
    )
    commonGuestFields['howDidYouHearOther'] = getObjVal(
      commonGuestFields['howDidYouHearOther']
    )
    commonGuestFields['visitComment'] = getObjVal(
      commonGuestFields['visitComment']
    )
    commonGuestFields['visitPurpose'] = getObjVal(
      commonGuestFields['visitPurpose']
    )
    commonGuestFields['whatMotivated'] = getObjVal(
      commonGuestFields['whatMotivated']
    )
    commonGuestFields['whatMotivatedOther'] = getObjVal(
      commonGuestFields['whatMotivatedOther']
    )
    commonGuestFields['peopleTakenIshaProgram'] = getObjVal(
      commonGuestFields['peopleTakenIshaProgram']
    )
    commonGuestFields['firstTimeVisits'] = getObjVal(
      commonGuestFields['firstTimeVisits']
    )
    commonGuestFields['volunteerHandlingBooking'] = getObjVal(
      commonGuestFields['volunteerHandlingBooking']
    )
    if (commonGuestFields['address']) {
      commonGuestFields['address']['street'] = getObjVal(
        commonGuestFields['address']['street']
      )
      commonGuestFields['address']['city'] = getObjVal(
        commonGuestFields['address']['city']
      )
      commonGuestFields['address']['state'] = getObjVal(
        commonGuestFields['address']['state']
      )
      commonGuestFields['address']['zip'] = getObjVal(
        commonGuestFields['address']['zip']
      )
      commonGuestFields['address']['country'] = getObjVal(
        commonGuestFields['address']['country']
      )
    }
  }
  return commonGuestFields
}
// ----------Page Refresh Methods end----------//



// WEBPACK FOOTER //
// ./src/redux/actions.js